import { useDispatch } from "react-redux";
import {
  LanguageData,
  deleteLocalizedLanguage,
} from "../../app/slices/TrainingLocalizationSlice";

export const useDeleteLanguage = () => {
  const dispatch = useDispatch();
  const deleteLanguage = (languageData: LanguageData) => {
    dispatch(deleteLocalizedLanguage(languageData));
  };

  return { deleteLanguage } as const;
};
